// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cRMh","name":"styles_name__qTR_M","phone":"styles_phone__3mAxv"};